import { Circle, G, Path, Rect, Svg } from "react-native-svg";

import { useTheme } from "~/styles/theme";

/**
 * The DoughBro logomark. Generated from the same geometry as the app
 * icon and the website favicon, so the three surfaces cannot drift apart.
 * Colours are the brand's own — a mark should not follow semantic tokens.
 */
const schemes = {
  light: { plate: "#faf6ee", ink: "#6b4226", accent: "#d4a04a" },
  dark: { plate: "#2c1a0e", ink: "#f5edd8", accent: "#d4a04a" },
} as const;

export function Logomark({ size = 26 }: { size?: number }) {
  const { scheme } = useTheme();
  const c = schemes[scheme === "dark" ? "dark" : "light"];
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      accessibilityLabel="DoughBro"
    >
      <Circle
        cx="32"
        cy="33"
        r="20"
        fill={c.accent}
        stroke={c.ink}
        strokeWidth="3"
      />
      <Path
        d="M20 38 C25 30, 32 24, 41 22"
        fill="none"
        stroke={c.ink}
        strokeWidth="4.5"
        strokeLinecap="round"
      />
      <Path
        d="M24 46 C29 38, 36 32, 45 30"
        fill="none"
        stroke={c.ink}
        strokeWidth="4.5"
        strokeLinecap="round"
      />
    </Svg>
  );
}
